module.exports = __webpack_public_path__ + "img/Trims_1200x800.0235d837.png";